import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {

  transform(value: any, args?: any): any {

    return value.substring(0, args);
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/truncate.pipe.ts